import {
  AccountsIcon,
  BriefcaseIcon,
  ClockIcon,
  DashboardIcon,
  DigitalCertificateIcon,
  DocAddIcon,
  DollarSignIcon,
  FolderIcon,
  HelpIcon,
  InvoiceIcon,
  ReleasesIcon,
} from "@ficatranquilo/contabilidade.com-ui";
import useHasCltContract from "../../hooks/useHasCltContract";
import { buildSidebarMenu } from "./sidebarMenu";

/**
 * Menu da Visão Colaborador, no Sidebar da lib. "Ponto" só aparece para quem tem contrato CLT ativo
 * (cache em sessionStorage para não consultar a cada navegação). A consulta só
 * roda com `enabled`, isto é, quando este menu é o que aparece.
 */
export function useMenuEmployee(enabled = true) {
  const hasCltContract = useHasCltContract(enabled);

  return buildSidebarMenu([
    { key: "dashboard", label: "Dashboard", icon: <DashboardIcon />, route: "/" },
    { key: "projects", label: "Projetos", icon: <BriefcaseIcon />, route: "/e/projects" },
    { key: "contracts", label: "Contratos", icon: <ReleasesIcon />, route: "/e/contracts" },
    hasCltContract && { key: "time-clock", label: "Ponto", icon: <ClockIcon />, route: "/e/time-clock" },
    {
      key: "financial",
      label: "Financeiro",
      icon: <DollarSignIcon />,
      items: [
        { key: "nfes", label: "Notas fiscais", icon: <DocAddIcon />, route: "/e/nfes" },
        { key: "payments", label: "Pagamentos", icon: <InvoiceIcon />, route: "/e/payment-schedules" },
        { key: "bank", label: "Dados bancários", icon: <AccountsIcon />, route: "/e/bank" },
      ],
    },
    {
      key: "content",
      label: "Documentos",
      icon: <FolderIcon />,
      items: [
        { key: "documents", label: "Documentos", icon: <FolderIcon />, route: "/e/documents" },
        { key: "quiz", label: "Questionários", icon: <HelpIcon />, route: "/e/quiz" },
        { key: "declarations", label: "Declarações", icon: <DigitalCertificateIcon />, route: "/e/declarations" },
      ],
    },
  ]);
}
